import logo from './logo.svg';
import './App.css';


import './helloWorld/helloWorld.css'
import HelloWorld from './helloWorld/helloWorld'

import { useEffect, useState } from 'react';

function App() {

  const [hello,setHello]=useState("hello World")

  const   showMessage=(s)=>{
    //console.log("Hello")

    setHello(s);
    //alert(s);
  }

  useEffect(()=>{
    //alert(hello)
  },[hello])

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <HelloWorld name={hello} onShow={showMessage}></HelloWorld>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default App;
